export default (() => {

    const global = {
        elements: {},
        fields: {},
    };

    function initialise(isRecurringPayment) {
        _cacheElements();
        _cachePageData(isRecurringPayment);
        _initialiseComponents();
    }

    function _cacheElements() {
        global.elements = {progressBar: document.querySelector('[data-progress-bar]')};
        global.fields = {
            sortCode: document.querySelector('[data-sort-code]'),
            accountNumber: document.querySelector('[data-account-number]')
        };
    }

    function _cachePageData (isRecurringPayment) {
        global.pageData = {
            portfolioId: document.querySelector('[data-portfolio-id]').value,
            isRecurringPayment: isRecurringPayment
        };
    }

    function _initialiseComponents () {
        _bindProgressBar();
    }

    function _bindProgressBar () {

        const recurringUrlFlag = global.pageData.isRecurringPayment ? 'Recurring' : '';

        global.elements.progressBar.steps = [
            {
                label: '1',
                titleprop: 'Options',
                state: 'complete',
                onclickprop: () => {
                    window.location = `${window.location.origin}${global.elements.progressBar.getAttribute('data-options-url') + recurringUrlFlag}/${global.pageData.portfolioId}`;
                },
            },
            {
                label: '2',
                titleprop: 'Your details',
                state: 'complete',
                onclickprop: () => {
                    window.location = `${window.location.origin}${global.elements.progressBar.getAttribute('data-details-url') + recurringUrlFlag}/${global.pageData.portfolioId}`;
                },
            },
            {
                label: '3',
                titleprop: 'Bank details',
                state: 'selected',
            },
            {
                label: '4',
                titleprop: 'Confirmation',
                disabledprop: true,
            },
        ];
    }

    return { initialise };
})();